import { BrowserRouter } from 'react-router-dom';
import { useThemeSchema } from '@/hooks/useThemeSchema.ts';
import Layout from '@/components/layouts';
import { AuthProvider } from '@/auth';
import Views from '@/views';

function App() {
  useThemeSchema();

  return (
    <BrowserRouter>
      <AuthProvider>
        <Layout>
          <Views />
        </Layout>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
